import FILTER_JSON from '../../assets/data/filter-list.json';
import { AdvancedFilterModel, stemsEQModel } from '../models/magic-search.model';
import { FilterListModel, FilterSubsListObj } from '../models/filter-list-model';

const filterList = FILTER_JSON as FilterListModel[];

const getSubList = (apiKey: string): FilterSubsListObj[] =>
  filterList.find(f => f.ApiFilterKey === apiKey)?.filter_sub_list ?? [];

export const MAGIC_SEARCH_GENRES: FilterSubsListObj[] = getSubList('genres');
export const MAGIC_SEARCH_MOODS: FilterSubsListObj[] = getSubList('moods');
export const MAGIC_SEARCH_KEYS: FilterSubsListObj[] = getSubList('keys');

export const MAGIC_SEARCH_STEM_IDS = ['drums', 'bass', 'melody', 'vocals', 'guitar', 'keys'] as const;
export type StemId = typeof MAGIC_SEARCH_STEM_IDS[number];

export const EQ_MIN = -12;
export const EQ_MAX = 12;

export const EQ_PRESETS: Record<string, Partial<Record<StemId, number>> | null> = {
  'Manual': null,
  'Vocal-forward': { drums: -2, bass: 0, melody: 4, vocals: 9, guitar: 0, keys: 2 },
  'Instrumental':  { drums: 3,  bass: 3, melody: 6, vocals: -12, guitar: 5, keys: 4 },
  'Drum-heavy':    { drums: 10, bass: 6, melody: -2, vocals: -3, guitar: -2, keys: -2 },
  'Flat':          { drums: 0,  bass: 0, melody: 0, vocals: 0, guitar: 0, keys: 0 },
};

export const DEFAULT_FILTERS: AdvancedFilterModel = {
  genre_whitelist: null,
  bpm_min: null,
  bpm_max: null,
  key: null,
  price_min: null,
  price_max: null,
  mood: null,
  stems: null,
};

export const DEFAULT_STEMS: stemsEQModel = {
  levels: { drums: 0, bass: 0, melody: 0, vocals: 0, guitar: 0, keys: 0 },
  muted: null,
};
